import React from 'react';
import { useFormContext } from 'react-hook-form';
const SpecialNeeds = () => {
  const {
    register
  } = useFormContext();
  return <div className="space-y-8" data-id="element-575">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-576">
        <p className="text-slate-700" data-id="element-577">
          Please provide information about any corporations, dependents with
          special needs, or other special considerations.
        </p>
      </div>
      {/* Corporate Information */}
      <div className="space-y-4" data-id="element-578">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-579">
          Corporate Information
        </h3>
        <div data-id="element-580">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-581">
            Do you own or have an interest in any corporations?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-582">
            <label className="inline-flex items-center" data-id="element-583">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('corporateInfo.exists')} data-id="element-584" />
              <span className="ml-2" data-id="element-585">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-586">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('corporateInfo.exists')} data-id="element-587" />
              <span className="ml-2" data-id="element-588">No</span>
            </label>
          </div>
        </div>
      </div>
      {/* Dependents with Special Needs */}
      <div className="space-y-4" data-id="element-589">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-590">
          Dependents with Special Needs
        </h3>
        <div data-id="element-591">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-592">
            Do you have any dependents with special needs?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-593">
            <label className="inline-flex items-center" data-id="element-594">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('specialNeeds.exists')} data-id="element-595" />
              <span className="ml-2" data-id="element-596">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-597">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('specialNeeds.exists')} data-id="element-598" />
              <span className="ml-2" data-id="element-599">No</span>
            </label>
          </div>
        </div>
      </div>
      {/* Other Special Considerations */}
      <div className="space-y-4" data-id="element-600">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-601">
          Other Special Considerations
        </h3>
        <div data-id="element-602">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-603">
            Are there any other special considerations we should be aware of?
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Please describe any other special considerations" {...register('specialConsiderations')} data-id="element-604" />
        </div>
      </div>
    </div>;
};
export default SpecialNeeds;